/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, createContext } from 'react';
import { Drawer } from '@one-thd/sui-atomic-components';
const DrawerContext = createContext(null);
const DrawerProvider = ({ children }) => {
    const initialState = {
        ContentComponent: null,
        componentProps: {},
        drawerProps: {},
        isOpened: false,
    };
    const [drawerState, setDrawerState] = useState(initialState);
    /**
     * openDrawer function.
     *
     * @param {React.FC} ContentComponent - a drawer content component
     * @param {any} [componentProps={}] - a drawer content component (ContentComponent) props
     * @param {IDrawerProps} [drawerProps={}] - a stencil drawer props
     *
     * @example
     *     const BasicDrawerContent = ({title}: string) => <p>This is a basic drawer's content. {title}</p>;
     *     // Update  stencil drawer props
     *     const drawerProps = { position: 'left' };
     *
     *     openDrawer(BasicDrawerContent, { title: 'Drawer Title' }, drawerProps);
     */
    const openDrawer = (ContentComponent, componentProps, drawerProps = {}) => {
        setDrawerState({
            ContentComponent,
            componentProps,
            drawerProps,
            isOpened: true,
        });
    };
    /**
     * hideDrawer function for hiding (closing) opened drawer
     *
     */
    const hideDrawer = () => {
        setDrawerState(({ drawerProps }) => ({
            ContentComponent: null,
            componentProps: {},
            drawerProps: {
                position: drawerProps.position,
            },
            isOpened: false,
        }));
    };
    const setComponentProps = (componentProps) => {
        setDrawerState((prevDrawerState) => (Object.assign(Object.assign({}, prevDrawerState), { componentProps: Object.assign(Object.assign({}, prevDrawerState.componentProps), componentProps) })));
    };
    return (React.createElement(DrawerContext.Provider, { value: {
            openDrawer,
            hideDrawer,
            isOpened: drawerState.isOpened,
            setComponentProps,
        } },
        React.createElement(Drawer, Object.assign({ open: drawerState.isOpened, onClose: hideDrawer }, drawerState.drawerProps), drawerState.ContentComponent && (React.createElement(drawerState.ContentComponent, Object.assign({ hideDrawer: hideDrawer }, drawerState.componentProps)))),
        children));
};
export { DrawerProvider, DrawerContext };
